// List of departments from Ghanaian universities
export const ghanaDepartments = [
  // Arts and Humanities
  "African Studies",
  "Archaeology",
  "Arts",
  "Classics",
  "Communication Studies",
  "Dance",
  "English",
  "Film Studies",
  "Fine Arts",
  "French",
  "Geography",
  "History",
  "Languages",
  "Linguistics",
  "Literature",
  "Media Studies",
  "Modern Languages",
  "Music",
  "Philosophy",
  "Religious Studies",
  "Theatre Arts",
  "Translation",
  
  // Business and Management
  "Accounting",
  "Banking and Finance",
  "Business Administration",
  "Commerce",
  "Economics",
  "Entrepreneurship",
  "Finance",
  "Human Resource Management",
  "Insurance",
  "International Business",
  "Management",
  "Marketing",
  "Public Administration",
  "Supply Chain Management",
  "Tourism and Hospitality Management",
  
  // Education
  "Adult Education",
  "Basic Education",
  "Childhood Education",
  "Curriculum Studies",
  "Education",
  "Educational Administration",
  "Educational Leadership",
  "Educational Psychology",
  "Physical Education",
  "Science Education",
  "Special Education",
  "Teacher Education",
  
  // Engineering and Technology
  "Aerospace Engineering",
  "Agricultural Engineering",
  "Biomedical Engineering",
  "Chemical Engineering",
  "Civil Engineering",
  "Computer Engineering",
  "Computer Science",
  "Electrical Engineering",
  "Electronic Engineering",
  "Environmental Engineering",
  "Food Process Engineering",
  "Geological Engineering",
  "Industrial Engineering",
  "Information Technology",
  "Materials Engineering",
  "Mechanical Engineering",
  "Metallurgical Engineering",
  "Mining Engineering",
  "Petroleum Engineering",
  "Software Engineering",
  "Telecommunication Engineering",
  
  // Health Sciences
  "Anesthesia",
  "Biomedical Science",
  "Dentistry",
  "Dietetics",
  "Medical Laboratory Science",
  "Medicine",
  "Midwifery",
  "Nursing",
  "Nutrition",
  "Occupational Therapy",
  "Optometry",
  "Pharmacy",
  "Physical Therapy",
  "Physician Assistant Studies",
  "Public Health",
  "Radiography",
  "Speech Therapy",
  "Veterinary Medicine",
  
  // Law
  "Law",
  "Legal Studies",
  
  // Natural Sciences
  "Actuarial Science",
  "Agricultural Science",
  "Animal Science",
  "Applied Mathematics",
  "Biochemistry",
  "Biology",
  "Botany",
  "Chemistry",
  "Crop Science",
  "Environmental Science",
  "Fisheries",
  "Food Science",
  "Forestry",
  "Geology",
  "Horticulture",
  "Marine Science",
  "Mathematics",
  "Meteorology",
  "Microbiology",
  "Molecular Biology",
  "Natural Resource Management",
  "Physics",
  "Statistics",
  "Zoology",
  
  // Social Sciences
  "Anthropology",
  "Criminology",
  "Development Studies",
  "International Relations",
  "Political Science",
  "Psychology",
  "Social Work",
  "Sociology",
  
  // Others
  "Architecture",
  "Fashion Design",
  "Graphic Design",
  "Interior Design",
  "Land Economy",
  "Planning",
  "Real Estate",
  "Urban Studies"
];
